import React, { useRef, useState, useEffect } from 'react';
import {
  convertStringToDate,
} from 'common';
import { sub } from 'date-fns';
import { useTranslation } from 'react-i18next';
import {
  DateField
} from '@sentara-health/optimahealth_web';
import { useFormContext } from 'react-hook-form';
import { isAvMed } from 'context';
import { retrieveBrandConst } from '../../common/utils/constants/Constants';

export const ONLY_DATE_FORMAT = /[^0-9/b]/;


export const DatePicker = ({
  dobValue = '',
  fieldName = 'dob',
  required = true,
  requiredMinAge = true,
}: any) => {
  const { t } = useTranslation();
  const [dateOfBirth, setDateOfBirth] = useState<string>('');

  const [maxDate, setMaxDate] = useState<Date>(new Date());
  const inputRef = useRef(null);
   const methods = useFormContext();
  const {setValue, formState: { errors }, clearErrors } = methods;
  
  //Set default date in the calendar for the Registration flow
  useEffect(() => {
    setDateOfBirth(dobValue);
  }, [dobValue]);
  
      // dob change handler
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue: string = e.target.value.replace(ONLY_DATE_FORMAT, "");
      setDateOfBirth(inputValue);
      setValue(fieldName, inputValue);
    };

    // calendar change handler
    const calendarListener = (val: any) => {
      const formattedVal = convertStringToDate(val);      
      setDateOfBirth(formattedVal);
      setValue(fieldName, formattedVal);
      clearErrors(fieldName);
    };

  const brandConst = retrieveBrandConst(isAvMed());
  useEffect(() => {
    // set max date for dob for registration flow.
    (async () => {
      const date = new Date();
        const minAge = sub(date, { years: (brandConst.minAge(requiredMinAge)) });
        let maxDate = fieldName === 'from' || fieldName === 'to' ? date : minAge;
        setMaxDate(maxDate);
    })();
  }, [fieldName]);

  const isValidDate = (dateString: string) => {
    if (!dateString || dateString.length !== 10) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date.getTime());
  };
   
  return (
    <DateField
      register={methods.register}
      error={errors.dob ? 'error-border' : ''}
      maxDate={
        fieldName === 'from' || fieldName === 'to'
          ? isValidDate(dateOfBirth)
            ? new Date(dateOfBirth)
            : new Date()
          : maxDate
      }
      fieldName={fieldName}
      onChangeHandler={onChangeHandler}
      dateOfBirth={dateOfBirth}
      required={required}
      dataTestId={'datepicker'}
      calendarListener={calendarListener}
      placeholder={
        fieldName === 'from' || fieldName === 'to'
          ? t('common.selectDate') || ''
          : t('common.dateOfBirthPlaceholder') || ''
      }
    />
  );
};
